import { ConfirmModal } from 'components/ui/modals/ConfirmModal/index.js';

import { useGlobalErrorHandlerEffects } from './GlobalErrorHandler.effects.js';
import {
  ErrorDescription,
  ErrorID,
  ErrorTitle,
} from './GlobalErrorHandler.styles.js';

export const GlobalErrorHandler = () => {
  const { open, parsedError, onClose } = useGlobalErrorHandlerEffects();

  return (
    <ConfirmModal
      open={open}
      actions={[
        {
          title: 'Close',
          onClick: onClose,
          buttonProps: { variant: 'contained' },
        },
      ]}
    >
      <ErrorTitle data-sentry-unmask>Error</ErrorTitle>
      <ErrorID gutterBottom data-sentry-unmask>
        Error ID:
        {parsedError?.errorId}
      </ErrorID>
      <ErrorDescription variant="body1">
        {parsedError?.message}
      </ErrorDescription>
    </ConfirmModal>
  );
};
